import { __assign } from "tslib";
import { getPrecisionForInterval, createDateFormatter, } from '@keen.io/charts-utils';
export var setChartSettings = function (_a) {
    var query = _a.query;
    var interval = query.interval;
    var settings = {};
    if (interval) {
        var precision = getPrecisionForInterval(interval);
        settings = __assign(__assign({}, settings), { yScaleSettings: {
                precision: precision,
                type: 'time',
                formatLabel: createDateFormatter(precision),
            } });
    }
    return settings;
};
